import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import '@/firebase';
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

if (process.env.NODE_ENV === "production") {
  console.log('PROD MODE');
  Sentry.init({
    dsn: 'https://460b8365e4fb43948e2510aa78c83e06@o392435.ingest.sentry.io/5239913',
    integrations: [new VueIntegration({
      Vue,
      attachProps: true,
      logErrors: true,
    })],
  });

  LogRocket.init('acquire/acquire', {
    release: '0.1.0',
  });

  LogRocket.getSessionURL(sessionURL => {
    Sentry.configureScope(scope => {
      scope.setExtra("sessionURL", sessionURL);
    });
  });
} else {
  console.debug('DEV MODE');
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
